import * as types from './mutation-types'
import cache from '@/common/js/cache'
import * as storageKey from '@/common/js/const'

const mutations = {
  [types.SET_USER](state, user) {
    state.user = user;
    cache.set(storageKey.storage_user, user);
  },
  [types.SET_TOKEN](state, token) {
    state.token = token;
    cache.set(storageKey.storage_token, token);
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js